<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" :form="form">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="评论标题">
            <a-input v-model="form.title" placeholder="请输入评论标题" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="评论用户">
            <a-input v-model="form.keywords" placeholder="输入/查询未知用户" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="内容类型">
            <a-select allowClear v-model="form.type" placeholder="请选择内容类型">
              <a-select-option v-for="item in LIKE_TYPE" :key="item.key" :value="item.key" :title="item.value">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="评论内容ID">
            <a-input v-model="form.map_id" placeholder="请输入评论内容ID" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="审核状态">
            <a-select allowClear v-model="form.check_status" placeholder="请选择审核状态">
              <a-select-option v-for="item in CHECK_STATUS" :key="item.key" :value="item.key" :title="item.value">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="是否删除">
            <a-select allowClear v-model="form.delete" placeholder="请选择是否删除">
              <a-select-option v-for="item in DEL_STATUS" :key="item.key" :value="item.key" :title="item.value">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="评论时间">
            <a-range-picker v-model="pickDate" />
          </a-form-item>
        </a-col>
        <div style="float:right;">
          <a-button @click="search" type="primary" style="margin-right: 10px">查询</a-button>
          <a-button @click="resetCondition">重置</a-button>
        </div>
      </a-row>
    </a-form>
    <a-table
      bordered
      @change="pageChange"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      rowKey="id"
      :scroll="{ x: 1600 }"
    >
      <template slot="type" slot-scope="text">
        {{ textFormat(text, 'LIKE_TYPE') }}
      </template>
      <template slot="approval_number" slot-scope="text, scoped">
        <p v-show="parseInt(scoped.approva_status) === 0">--</p>
        <p v-show="parseInt(scoped.approva_status) === 1">
          {{ scoped.approval_name }} <span v-show="parseInt(text)">({{ text }})</span>
        </p>
        <p v-show="parseInt(scoped.approva_status) === 2">--</p>
      </template>
      <template slot="is_del" slot-scope="text">
        {{ textFormat(text, 'DEL') }}
      </template>
      <template slot="floor" slot-scope="text, scoped">
        {{ scoped.parent_id === '0' ? `${text}楼` : '--' }}
      </template>
      <template slot="approva_status" slot-scope="text">
        <span style="color: #FE9501;" v-show="parseInt(text) === 0">{{ textFormat(text, 'CHECK_STATUS') }}</span>
        <span style="color: #18BE6B;" v-show="parseInt(text) === 1">{{ textFormat(text, 'CHECK_STATUS') }}</span>
        <span style="color:red;" v-show="parseInt(text) === 2">{{ textFormat(text, 'CHECK_STATUS') }}</span>
      </template>
      <template slot="created_at" slot-scope="text, scoped">
        <p style="margin:0;">评论时间：{{ text | time }}</p>
        <p style="margin:0;">
          审核时间：<span v-if="parseInt(scoped.approva_at)">{{ scoped.approva_at | time }}</span>
          <span v-else>--</span>
        </p>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-popconfirm
          title="审核评论"
          @confirm="anditArticle(record.id, 1)"
          @cancel="anditArticle(record.id, 2)"
          ok-text="通过"
          cancel-text="驳回"
        >
          <a href="#">审核</a>
        </a-popconfirm>
        <a-button type="link" @click="$refs.viewDetail.open(record.id)" size="small">查看</a-button>
        <a-button v-if="record.is_del === '0'" @click="delItem(record.id, 1)" type="link" size="small">删除</a-button>
        <a-button v-else @click="delItem(record.id, 0)" type="link" size="small">恢复</a-button>
        <a-button
          @click="$router.push({ path: `/group-web/article/review/${record.id}` })"
          v-if="record.reply_num > 0"
          type="link"
          size="small"
        >查看回复</a-button
        >
      </template>
    </a-table>
    <commentDetail ref="viewDetail" />
  </div>
</template>

<script>
import commentDetail from './components/commentDetail.vue'
import { viewColumns } from './business/index'
import moment from 'moment'
import { mapState } from 'vuex'
import { reviewList, dealView } from '@/api/groupWeb/article'
import _ from 'lodash'
const ISearchFrom = () => {
  return {
    map_id: undefined, //  评论内容ID
    endTime: undefined, //  评论时间结束时间
    startTime: undefined, //  评论时间开始时间
    title: undefined, //  评论标题
    type: undefined, // 内容类型（1期刊  2文章）
    keywords: undefined, //  评论用户工号|姓名
    check_status: undefined, //  审核状态
    delete: undefined //  是否删除
  }
}

export default {
  components: { commentDetail },
  computed: {
    ...mapState(['label']),
    LIKE_TYPE() {
      return this.label?.data?.POSTS?.LIKE_TYPE || []
    },
    CHECK_STATUS() {
      return this.label?.data?.POSTS?.CHECK_STATUS || []
    },
    DEL_STATUS() {
      return this.label?.data?.POSTS?.DEL || []
    }
  },
  watch: {
    pickDate: {
      handler(val) {
        this.form.startTime = val.length ? moment(val[0]).format('YYYY-MM-DD') : ''
        this.form.endTime = val.length ? moment(val[1]).format('YYYY-MM-DD') : ''
      },
      immediate: true
    },
    $route: {
      handler(route) {
        if (route.query?.id) {
          this.form.map_id = route.query.id
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      columns: viewColumns,
      dataSource: [],
      pickDate: [],
      form: ISearchFrom(),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true
      }
    }
  },
  filters: {
    time(msg) {
      return (msg = moment(msg * 1000).format('YYYY-MM-DD HH:mm:ss'))
    }
  },
  methods: {
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.getList()
    },
    delItem(id, is_del) {
      this.$confirm({
        title: is_del === 1 ? '是否确定删除该评论？' : '是否确定恢复该评论？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          const res = await dealView({ id, is_del })
          this.doingSuccess(res)
        }
      })
    },
    doingSuccess(res) {
      if (res.code === '000000') {
        this.$message.success('操作成功')
        this.getList()
      }
    },
    anditArticle(id, approva_status) {
      dealView({ id, approva_status }).then(res => this.doingSuccess(res))
    },
    textFormat(text, key) {
      return this.label.data?.POSTS?.[key].find(d => d.key === Number(text))?.value
    },
    resetCondition() {
      this.pagination.current = 1
      this.pickDate = []
      this.form = ISearchFrom()
      this.getList()
    },
    search() {
      this.pagination.current = 1
      this.getList()
    },

    async getList() {
      const params = Object.assign({}, this.form, {
        page: this.pagination.current,
        per_page: this.pagination.pageSize
      })
      this.loading = true
      try {
        const { data } = await reviewList(params)
        this.pagination.pageSize = data?.pagination?.per_page || 10
        this.pagination.current = data?.pagination?.page || 1
        this.pagination.total = data?.pagination?.total || 0
        this.dataSource = data?.list
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="less" scoped></style>
